/* eslint-disable camelcase */
import 'moment/locale/pt-br';

export function symbolFormatter(valor) {
	return Number(valor).toLocaleString('pt-BR', {
		style: 'currency',
		currency: 'BRL',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
}

export function symbolPriceFormatter(valor, from = null) {
	if (valor !== null) {
		if (from === 'detalheLink') {
			return Number(valor / 100).toLocaleString('pt-BR', {
				style: 'currency',
				currency: 'BRL',
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			});
		}
		return Number(valor).toLocaleString('pt-BR', {
			style: 'currency',
			currency: 'BRL',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});
	}
	return 'R$ 0,00';
}

export function symbolPriceFormatterSplit(valor, valor_total) {
	if (valor !== null) {
		return Number((valor_total * valor) / 100).toLocaleString('pt-BR', {
			style: 'currency',
			currency: 'BRL',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});
	}
	return 'R$ 0,00';
}

export function priceFormatter(valor) {
	return Number(valor).toLocaleString('pt-BR', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
}

export function convertPriceToNumber(valor) {
	if (valor === '') {
		return 0;
	}
	let novoValor = '';
	for (let i = 0; i < valor.length; i += 1) {
		novoValor += valor[i].replace('.', '').replace(',', '.');
	}
	return parseFloat(novoValor);
}

export function convertPriceToInt(valor) {
	if (valor === '') {
		return 0;
	}
	let novoValor = '';
	for (let i = 0; i < valor.length; i += 1) {
		novoValor += valor[i].replace('.', '').replace(',', '.');
	}
	return parseInt(novoValor * 100, 10);
}

export function tablePriceSymbolFormatter(valor) {
	return symbolPriceFormatter(valor);
}

export function verificaPorcentagem(valorInicial, valorFinal) {
	let valorInicio = valorInicial;
	let valorFim = valorFinal;

	if (valorInicial === null || valorInicial === undefined) {
		valorInicio = 0;
	}
	if (valorFinal === null || valorInicial === undefined) {
		valorFim = 0;
	}

	if (valorInicio > valorFim) {
		const diferenca = valorInicio - valorFim;
		const result = (diferenca * 100) / valorInicio;
		return `+${result.toFixed(0)}%`;
	}
	if (valorFim > valorInicio) {
		const diferenca = valorFim - valorInicio;

		const result = (diferenca * 100) / valorFim;

		return `-${result.toFixed(0)}%`;
	}

	return '0%';
}
